module.exports = __webpack_public_path__ + "static/media/logo512.f27de69e.png";